(function(){
    'use strict'

    angular
    .module('app.reportes')
    .controller('ReportePlanillaPorCC', ReportePlanillaPorCC);

    ReportePlanillaPorCC.$inject = ['$scope', '$animationsSrv', 'ProcesarPlanillaService', 'CalendarizacionesService', 'TiposPlanillaService', 'logger', '$location', 'UserInfoService', 'moment', 'BloqueoXUsuarioService', 'ReportesService'];

    function ReportePlanillaPorCC($scope, $animationsSrv, ProcesarPlanillaService, CalendarizacionesService, TiposPlanillaService, logger, $location, UserInfoService, moment, BloqueoXUsuarioService, ReportesService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.detallado = false;

        vm.tiposPlanilla = [];
        vm.procesarPlanilla = {
            tipoPlanillaId: -1
        };
        vm.calendarizaciones = [];

        vm.title = 'General Planilla';

        getTiposPlanilla();

        function getTiposPlanilla(){
            var promise = TiposPlanillaService.getAllForCalendarizacion(UserInfoService.getCompaniaId())
            .then(function(tiposPlanilla){
                tiposPlanilla.forEach(tipo => {
                    tipo.fechaInicio = moment(tipo.fechaInicio).toDate();
                    tipo.fechaFinal = moment(tipo.fechaFinal).toDate();
                });
                vm.tiposPlanilla = tiposPlanilla;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de planilla.');
            }); 
            
            return promise;
        };

        function getAll(tipoPlanillaId){

            var promise = CalendarizacionesService.getAll(UserInfoService.getCompaniaId(), tipoPlanillaId);

            promise
            .then(function(calendarizaciones){
                calendarizaciones.forEach(calendarizacion => {
                    calendarizacion.fechaInicio = moment(calendarizacion.fechaInicio).toDate();
                    calendarizacion.fechaFinal = moment(calendarizacion.fechaFinal).toDate();
                });
                vm.calendarizaciones = calendarizaciones;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener las Planillas.');
                        break;
                }
                
            });
        };

        vm.tipoPlanillaChange = function(tipoPlanillaId){
            if(tipoPlanillaId && tipoPlanillaId !== -1){
                getAll(tipoPlanillaId);
            }          
        };
        

        vm.generar = function(calendarizacion) {
            var promise = null;
                
            promise = ReportesService.getPlanillaPorCC(calendarizacion.id);

            promise
            .then(function(response){
                logger.success('Reporte Generado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(`Hubo un error al generar el reporte: ${error.data.Message}`);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un error al generar el reporte');
                        break;
                }
            }); 
        };   

    }
})();